module.exports = __webpack_public_path__ + "static/media/svg3.02f0b331.svg";